import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import Navbar from '../../../components/organism/navbar/index.tsx'
import Footer from '../../../components/organism/footer/index.tsx'

// plannerUnsubscribe (functions/src/planner/unsubscribe.js) performs the
// actual unsubscribe itself when a human clicks the emailed link: that GET
// request goes to /api/unsubscribe, which firebase.json rewrites straight to
// the function (before that, the raw https://<region>-<project>
// .cloudfunctions.net URL was hardcoded here and this page did the write via
// fetch — but Gmail's one-click RFC 8058 POST hits that same email link
// directly, with no browser and no JS, so the write has to happen on the
// GET/POST itself rather than in this page). The function then 302-redirects
// here with ?status=done or ?status=error, so by the time this component
// mounts the outcome is already decided — no fetch, no loading state.
const Unsubscribe: React.FC = () => {
	const { t } = useTranslation('planner')
	const [searchParams] = useSearchParams()
	const status = searchParams.get('status') === 'done' ? 'done' : 'error'

	return (
		<div className='body-container'>
			<Navbar scrollToContact={() => {}} />
			<div style={{ padding: '120px 24px', textAlign: 'center' }}>
				{status === 'done' && <h1>{t('unsubscribe.done')}</h1>}
				{status === 'error' && <h1>{t('unsubscribe.error')}</h1>}
			</div>
			<Footer />
		</div>
	)
}

export default Unsubscribe
